import { ChangeEvent, useCallback } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { TermsListSpace } from 'src/types/api'
import { AllTermsBooleanType, JoinFormType } from 'src/types/react-hook-form'
import { getRequiredTermKeys } from './getRequiredTermsFromApi'

export function useTermsAgreement(
  termsData: TermsListSpace.AllTermsType & { Idx: number },
  methods: UseFormReturn<JoinFormType>,
) {
  const { setValue, getValues } = methods
  const requiredTermsList = getRequiredTermKeys(termsData)

  const allTermsAgreeHandler = useCallback(() => {
    const values = getValues()
    let value = getValues('allTerms')

    for (const key of Object.keys(values)) {
      if (requiredTermsList.includes(key)) {
        value = value && (getValues(key as keyof AllTermsBooleanType) as boolean)
        setValue(key as keyof AllTermsBooleanType, !value)
      }
    }

    setValue('allTerms', !getValues('allTerms'))
  }, [getValues, requiredTermsList, setValue])

  const updateAllTermsAgree = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const clickTermsValue = event.target.checked
      const excludeClickTermsList = requiredTermsList.filter((w) => w !== event.target.name)
      const values = getValues(excludeClickTermsList as (keyof TermsListSpace.AllTermsType)[])

      const allAgreed = [...values, clickTermsValue]?.every((value) => value)

      setValue(event.target.name as keyof TermsListSpace.AllTermsType, event.target.checked)
      setValue('allTerms', allAgreed)
    },
    [getValues, requiredTermsList, setValue],
  )

  return { requiredTermsList, allTermsAgreeHandler, updateAllTermsAgree }
}
